module.exports = __webpack_public_path__ + "static/media/workshop-dev-tools.a21873da.jpg";